import { copyBotTemplateService } from '../../../services/boteria/copyBotTemplate';

export function CopyBotTemplate (user) {    
	return {
		type: 'COPY_BOT_TEMPLATE',
		payload: copyBotTemplateService(user)
	}
}